<template>
  <aicc-page :pageId="this.contextPageId">
    <ur-area>
      <ur-form-box toggleable column="10">
        <ur-form-row>
          <ur-form-item
            :label="$t('MSG_TXT_CAMPAIGN_PERIOD')"
            colSpan="3"
            labelAlign="right"
          >
            <aicc-range-picker
              v-model="rangeDate"
              init="day-2"
              style="width: 280px"
              inputType="YYYY-MM-DD"
              modelType="YYYYMMDD"
              :min-date="minDate"
              confirmLabel="확인"
              cancelLabel="취소"
              strict-range
              autoConfirm
              limitRange="31"
            ></aicc-range-picker>
          </ur-form-item>
          <ur-form-item
            :label="$t('MSG_TXT_CAMPAIGN')"
            colSpan="3"
            labelAlign="right"
          >
            <autoMultiDropdown
              v-model="selectedcampaignValue"
              selectAll
              :items="campaignItems"
              :itemsSize="240"
              placeholder="전체"
              selectedAllText="전체"
            />
          </ur-form-item>
          <ur-form-item
            :label="$t('MSG_TXT_RESULT_DATA')"
            colSpan="3"
            labelAlign="right"
          >
            <custom-text-field
              v-model="outcallResultData"
              clearable
              @click-icon-clear="onClearOutcallResultData"
              @blur="onBlurTrim"
              placeholder="처리결과 수기입력(선택)"
              style="width: 200px"
            />
          </ur-form-item>
          <ur-form-item />
        </ur-form-row>
        <ur-form-row>
          <ur-form-item
            :label="$t('MSG_TXT_OUTCALL_RESULT_DATA')"
            colSpan="3"
            labelAlign="right"
          >
            <autoMultiDropdown
              :items="outcallResultItems"
              v-model="selectedOutcallResult"
              selectAll
              :searchable="false"
              :itemsSize="240"
              placeholder="전체"
            />
          </ur-form-item>
          <ur-form-item
            :label="$t('MSG_TXT_SCENARIO_STATUS')"
            colSpan="3"
            labelAlign="right"
          >
            <autoMultiDropdown
              :items="scenarioTypeItems"
              v-model="selectedScenarioType"
              selectAll
              :searchable="false"
              :itemsSize="240"
              placeholder="전체"
            />
          </ur-form-item>
          <ur-form-item
            :label="$t('MSG_TXT_CALLEE_NUMBER1')"
            colSpan="3"
            labelAlign="right"
          >
            <!--ur-text-field ref="inputCallNumber" v-model="inputcalleenumber" :clearable="true" :rules="calleenumValidateRule" placeholder="수신번호 수기입력(선택)" style="width:200px;"/-->
            <custom-text-field
              ref="inputCallNumber"
              v-model="inputcalleenumber"
              clearable
              :rules="calleenumValidateRule"
              @click-icon-clear="onClearText"
              placeholder="수신번호 수기입력(선택)"
              style="width: 200px"
            />
          </ur-form-item>
          <ur-form-item noLabel noFlex>
            <ur-button solid primary @click="onClickSearch">{{
              $t("MSG_BTN_SRCH2")
            }}</ur-button>
          </ur-form-item>
        </ur-form-row>
      </ur-form-box>
      <ur-data-grid
        ref="gridScenario"
        :headers="headers"
        :data-source="tableItems"
        :options="tableOptions"
      >
        <template #right-info>
          <ur-button shape="solid" color="white" @click="onClickCommDownload">{{
            $t("MSG_BTN_COMM_DLOAD")
          }}</ur-button>
          <span class="my-divider"> | </span>
          <ur-button shape="solid" color="white" @click="onClickCsvDownload">{{
            $t("MSG_BTN_HISTORY_DLOAD")
          }}</ur-button>
        </template>
        <template #header>
          <ur-data-grid-header-row>
            <ur-data-grid-header-cell />
            <ur-data-grid-header-cell />
            <ur-data-grid-header-cell />
            <ur-data-grid-header-cell />
            <ur-data-grid-header-cell />
            <ur-data-grid-header-cell class="yoo_minwidth" />
            <ur-data-grid-header-cell class="yoo_wordbreak" />
            <ur-data-grid-header-cell class="yoo_wordbreak" />
            <ur-data-grid-header-cell class="yoo_wordbreak" />
            <ur-data-grid-header-cell />
            <ur-data-grid-header-cell class="yoo_wordbreak" />
            <ur-data-grid-header-cell />
            <ur-data-grid-header-cell />
            <ur-data-grid-header-cell>
              {{ headers[13].text }}
              <ur-icon type="line" id="home">information</ur-icon>
              <ur-tooltip target-id="home" bottom mouse-over>
                <div class="tooltip multi">
                  <ul class="progress_bar_state">
                    <li class="p1">질문의도 충족</li>
                    <li class="p2">반복 후 의도충족</li>
                    <li class="p3">질문의도 미충족</li>
                    <li class="p4">미응답</li>
                  </ul>
                </div>
              </ur-tooltip>
            </ur-data-grid-header-cell>
          </ur-data-grid-header-row>
        </template>
      </ur-data-grid>

      <aicc-recording-modal ref="recordModal" :convDataset="modalDataset" />
      <aicc-conversation-modal ref="convModal" :convDataset="modalDataset" />

      <!-- 스낵바 -->
      <ur-snackbar ref="snackbar" :duration="3000" />
    </ur-area>
    <div class="more_info_yoo">
      <div>
        * 수행이력 결과는 선택한 캠페인의 대기건을 포함하여 표시됩니다. 대기건은
        '통화연결'조회 조건에서 제외할 수 있습니다.
      </div>
    </div>
  </aicc-page>
</template>
 
<script>
import BasePage from "~cm/components/BasePage";
import autoMultiDropdown from "../../components/CMP_AIC_00001.vue";
import urDataGrid from "@uidev/grid/urDataGrid/urDataGrid";
import { urDataSet } from "uidev-component/index.js";
import customTextField from "../../components/CMP_AIC_00003/CMP_AIC_00003_C01";

// 7~20자리 숫자만 입력 가능(해외 발신 고려)
const PHONE_REGEX = /^\d{7,20}$/;

export default {
  name: "PGE_AIC_00001", // eslint-disable-line vue/name-property-casing
  components: {
    autoMultiDropdown,
    urDataGrid,
    customTextField: customTextField,
  },
  extends: BasePage,
  data() {
    return {
      tableItems: new urDataSet(),
      autoConfirm: true,
      options: {
        infinityScroll: true,
        noBaseInfo: false,
        internalPaging: true,
      },
      tableOptions: {
        infinityScroll: true,
        msgTotal: "총 #",
        timezone: +9,
        msgEmptyData: "",
        height: 0,
      },
      headers: [
        {
          text: this.$i18n.t("MSG_TXT_OUTCALL_RESULT_DATA"),
          value: "callResult",
          sort: true,
          align: "left",
          type: "code",
          width: "115px",
          freeze: true,
          domain: [
            { value: "N", text: "대기" },
            { value: "R", text: "연결중(링잉)" },
            { value: "A", text: "실패(무응답)" },
            { value: "B", text: "실패(통화중)" },
            { value: "C", text: "실패(결번)" },
            { value: "D", text: "실패(전화꺼짐)" },
            { value: "E", text: "실패(착신거부)" },
            { value: "Y", text: "연결" },
            { value: "G", text: "실패(기타)" },
            { value: "H", text: "실패(시나리오)" },
            { value: "", text: "Pending" },
          ],
          component: {
            props: ["row", "value", "text"],
            template: `<span class="c-cell"><ur-badge :color="badgeColor" shape="dot" :text="text"/></span>`,
            computed: {
              badgeColor() {
                return (
                  {
                    N: "default",
                    R: "default",
                    A: "error",
                    B: "error",
                    C: "error",
                    D: "error",
                    E: "error",
                    G: "error",
                    H: "error",
                    Y: "processing",
                  }[this.value] || "default"
                );
              },
            },
          },
        },
        {
          text: "수행일시",
          value: "outcallReqTime",
          sort: (x, y) => {
            // 1. check null
            if (!x && !y) return 0;
            if (!x) return 1;
            if (!y) return -1;

            if (x === y) return 0;
            if (x > y) return 1;
            return -1;
          },
          dateFormat: "YYYY-MM-DD HH:mm",
          type: "date",
          timezone: +9,
          width: "126px",
          freeze: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_START"),
          value: "startTime",
          width: "72px",
          dateFormat: "HH:mm:ss",
          type: "date",
          timezone: +9,
          freeze: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_END2"),
          value: "endTime",
          width: "72px",
          dateFormat: "HH:mm:ss",
          type: "date",
          timezone: +9,
          freeze: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_CALLEE_NUMBER1"),
          value: "calleeNumber",
          width: "120px",
          freeze: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_CAMPAIGN"),
          value: "scheduleName",
          sort: true,
          freeze: true,
          width: "200px",
          component: {
            props: ["row", "value", "text"],
            template: '<span :v-ur-tooltip="value">{{value}}</span>',
          },
        },
        {
          text: this.$i18n.t("MSG_TXT_CALLEE_ID"),
          value: "calleeId",
          width: "88px",
          freeze: true,
          sort: true,
        },
        {
          text: "시나리오 시작/종료",
          value: "scenarioStartEnd",
          freeze: true,
          align: "center",
          width: "88px",
          customClass: function (v, r) {
            if (v.start === "Y" && v.end === "Y") return "check_check";
            if (v.start === "Y" && v.end === "N") return "check_nonCheck";
            if (v.start === "N" && v.end === "Y") return "nonCheck_check";
            return "nonCheck_nonCheck";
          },
        },
        {
          text: "시도 순서",
          value: "retryTimes",
          freeze: true,
          width: "72px",
          sort: true,
          customValue: (v, r) => {
            if (v === -1) return "-";
            return v.toString() + "회";
          },
        },
        {
          text: this.$i18n.t("MSG_TXT_RESERVATION"),
          value: "insertReason",
          width: "72px",
          sort: (x, y) => {
            // 1. check null
            if (!x && !y) return 0;
            if (!x) return 1;
            if (!y) return -1;
            var newX = x === "B" ? 0 : 1;
            var newY = y === "B" ? 0 : 1;
            if (newX === newY) return 0;
            if (newX > newY) return 1;
            return -1;
          },
          freeze: true,
          customClass: function (v, r) {
            if (v === "B") return "check";
            return "nonCheck";
          },
        },
        {
          text: "상담원 요청",
          value: "callTxMark",
          width: "72px",
          sort: (x, y) => {
            // 1. check null
            if (!x && !y) return 0;
            if (!x) return 1;
            if (!y) return -1;
            var newX = x === "Y" ? 0 : 1;
            var newY = y === "Y" ? 0 : 1;
            if (newX === newY) return 0;
            if (newX > newY) return 1;
            return -1;
          },
          freeze: true,
          customClass: function (v, r) {
            if (v === "Y") return "check";
            return "nonCheck";
          },
        },
        {
          text: this.$i18n.t("MSG_TXT_RESULT_DATA"),
          value: "outcallResultData",
          width: "128px",
          freeze: true,
          sort: (x, y) => {
            if (!x && !y) return 0;
            if (!x) return -1;
            if (!y) return 1;

            if (x === y) return 0;
            if (x > y) return 1;
            return -1;
          },
          customClass: function (v, r) {
            if (utils.isEmpty(v)) return "nonCheck";
          },
        },
        {
          text: this.$i18n.t("MSG_TXT_CONVERSATION_HISTORY"),
          value: "itemIndex",
          align: "center",
          freeze: true,
          width: "72px",
          component: {
            props: ["row", "value", "text"],
            template:
              '<span><span v-if="onCheckSuccess(row)">\
              <span v-if="onCheckRecordExist(row)">\
                <button type="button" class="btn btn_play" @click="onClickRecModal(row)">듣기</button>\
              </span><span v-else>\
                <button type="button" class="btn btn_play" disabled @click="onClickRecModal(row)">듣기</button>\
              </span>\
              <button type="button" class="btn btn_stt" @click="onClickConvModal(row)">보기</button>\
              </span>\
              <span v-else>\
              <span class="nonCheck"/> <span class="nonCheck"/>\
              </span></span>',
            methods: {
              onCheckSuccess(row) {
                if (row.callResult === "Y") return true;
                return false;
              },
              onCheckRecordExist(row) {
                if (row.recordExistYn === "Y") return true;
                return false;
              },
              setData(row) {
                var component = this.getComponent("PGE_AIC_00001");
                component.modalDataset.itemIndex = row.itemIndex;
                component.modalDataset.scheduleId = row.scheduleId;
                component.modalDataset.scheduleName = row.scheduleName;
                component.modalDataset.conversationTime = row.outcallReqTime;
                component.modalDataset.calleeNumber = row.calleeNumber;
                component.modalDataset.scenarioName = row.scenarioName;
                component.modalDataset.retryTimes = row.retryTimes;
                component.modalDataset.callTxMark = row.callTxMark;
                component.modalDataset.insertReason = row.insertReason;
                component.modalDataset.scenarioStartEnd = row.scenarioStartEnd;
                component.modalDataset.startTime = row.startTime;
                component.modalDataset.endTime = row.endTime;
                component.modalDataset.sessionId = row.sessionId;
                component.modalDataset.itemStatus = row.itemStatus;
              },
              onClickConvModal(row) {
                this.setData(row);
                this.getComponent("PGE_AIC_00001").$refs["convModal"].open();
              },
              onClickRecModal(row) {
                this.setData(row);
                this.getComponent("PGE_AIC_00001").$refs["recordModal"].open();
              },
              getComponent(name) {
                let component = null;
                let thisComponent = this;
                while (thisComponent && !component) {
                  if (thisComponent.$options.name === name) {
                    component = thisComponent;
                    break;
                  }
                  thisComponent = thisComponent.$parent;
                }
                return component;
              },
            },
          },
        },
        {
          text: this.$i18n.t("MSG_TXT_SCENARIO_PROGRESS"),
          value: "answerList",
          width: "10000px", // 초기값
          customValue: () => { ''; }, // tooltip 생략
          component: {
            props: ["row", "value", "text"],
            template:
              '<span v-if="onCheckSuccess(row)" v-ur-tooltip.overflow.empty=""><aicc-scenario-progress-bar :items="row.answerSet"/></span>',
            methods: {
              onCheckSuccess(row) {
                if (row.callResult === "Y") return true;
                return false;
              },
            },
          },
        },
      ],
      scenarioProgressMaxSize: 0,
      scenarioProgressMinSize: 200, // 시나리오 진행 데이터가 없어도 컬럼명 표시를 위한 최소 width
      selectedScenarioInfo: [],
      campaignListAsk: {
        tenantId: this.$store.getters.userInfo.tenantId,
        sdate: "",
        edate: "",
      },
      rangeDate: [],
      minDate: "2021-01-01",
      selectedcampaignValue: [],
      campaignDropdown: [],
      selectedScenarioType: [],
      selectedTellerCallType: "AL",
      selectedOutcallResult: [],
      placeholder: this.$t("MSG_TXT_ALL"),
      outcallResultData: "",
      inputcalleenumber: "",
      objScenarioList: [],
      dataList: [],
      scenarioColMax: 1,
      scenarioTypeItems: [],
      outcallResultItems: [],
      tellerSelectItems: [
        { value: "AL", text: "전체" },
        { value: "TY", text: "상담원 요청" },
        { value: "TN", text: "상담원 미요청" },
      ],
      callResultTextMap: {
        N: "대기",
        R: "연결중(링잉)",
        Y: "연결",
        A: "실패(무응답)",
        B: "실패(통화중)",
        C: "실패(결번)",
        D: "실패(전화꺼짐)",
        E: "실패(착신거부)",
        G: "실패(기타)",
        H: "실패(시나리오)",
      },
      callResultFlagMap: {
        OB000: "Y",
        CA019: "A",
        CA017: "B",
        CA001: "C",
        CA022: "C",
        CA028: "C",
        CA018: "D",
        CA021: "E",
        CA025: "G",
        CA038: "G",
        CA041: "G",
        CA063: "G",
        CA079: "G",
        CA098: "G",
        CA102: "G",
        CA111: "G",
        CA127: "G",
        CA480: "G",
        CA500: "G",
        CA501: "G",
        CA502: "G",
        OB001: "N",
        OB002: "N",
        CA999: "G",
        SM101: "G",
        SM102: "H",
        SM103: "G",
        SM104: "G",
        SM105: "G",
        SM106: "G",
        SM107: "G",
        SM109: "G",
        SM110: "G",
      },
      calleenumValidateRule: [
        // 3자 미만이나 다른 문자 입력 후 조회버튼 클릭 시 필드 하단 붉은 폰트 얼럿메시지 노출
        (v) => this.inputLengthCheck(v) || "입력값 확인 필요",
      ],
      conversationDataAsk: {
        requestId: "",
        outcallId: "",
      },
      modalDataset: {
        pageid: this.$options.name,
        itemIndex: "",
        scheduleId: "",
        campaignName: "",
        conversationTime: "",
        calleeNumber: "",
        scenarioName: "",
        retryTimes: "",
        callTxMark: "",
        insertReason: "",
        scenarioStartEnd: "",
        startTime: "",
        endTime: "",
        sessionId: "",
        itemStatus: "",
      },
    };
  },
  created() {},
  computed: {
    campaignItems() {
      return this.campaignDropdown;
    },
  },
  watch: {
    rangeDate: function (newVal, oldVal) {
      this.onCampaignList();
      // 조회조건 초기화
      this.resetSearchConditions();
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
      this.tableOptions.height =
        $(".ur-area").css("height").replace("px", "") - 265;
      window.addEventListener("resize", this.handleResize);
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  destroyed() {},
  methods: {
    resetSearchConditions() {
      this.onClearText();
      this.onClearOutcallResultData();
      this.selectedTellerCallType = "AL";

      this.selectedScenarioType = [];
      this.selectedOutcallResult = [];
      this.scenarioTypeItems = [];
      this.outcallResultItems = [];

      const tempScenarioType = this.getScenarioTypeItems();

      for (let index in tempScenarioType) {
        this.scenarioTypeItems.push(tempScenarioType[index]);
        this.selectedScenarioType.push(tempScenarioType[index]);
      }

      const tempOutcallResult = this.getOutcallResultItems();

      for (let index in tempOutcallResult) {
        this.outcallResultItems.push(tempOutcallResult[index]);
        this.selectedOutcallResult.push(tempOutcallResult[index]);
      }
    },
    getScenarioTypeItems() {
      return [
        { value: "SY", text: "시나리오 시작 확인" },
        { value: "SN", text: "시나리오 시작 미확인" },
        { value: "EY", text: "시나리오 종료 확인" },
        { value: "EN", text: "시나리오 종료 미확인" },
      ];
    },
    getOutcallResultItems() {
      return [
        { value: "SC", text: "연결" },
        { value: "FL", text: "실패" },
        { value: "WT", text: "대기" },
      ];
    },
    handleResize(event) {
      this.$nextTick(() => {
        this.tableOptions.height =
          $(".ur-area").css("height").replace("px", "") - 265;
      });
    },
    inputLengthCheck(v) {
      var newv = v.trim();
      if (newv.length === 0) return true;
      return PHONE_REGEX.test(newv);
    },
    onBlurTrim() {
      this.outcallResultData = this.outcallResultData.trim();
    },
    onClearOutcallResultData() {
      this.outcallResultData = "";
    },
    onClearText() {
      this.inputcalleenumber = "";
      this.$refs["inputCallNumber"].clearValidation();
    },
    onLoad() {
      console.log(this.$store.getters.userInfo.tenantId);
      //this.selectedScenarioType = this.scenarioTypeItems;
      //this.selectedOutcallResult = this.outcallResultItems;
      //this.resetSearchConditions();
      this.onLoadData();
    },
    onLoadData() {
      this.campaignListAsk.sdate = this.rangeDate[0];
      this.campaignListAsk.edate = this.rangeDate[1];

      http
        .request(this.contextPageId, "DTS_AIC_00001", {
          query: this.campaignListAsk,
        })
        .then((response) => {
          const items = [];
          utils.forEach(response.data.list, (obj) => {
            items.push({ text: obj.scheduleName, value: obj.scheduleId });
          });
          this.campaignDropdown = items;
          this.selectedcampaignValue = items;
        })
        .then((result) => {
          this.onClickSearch("1");
        });
    },
    onCampaignList() {
      this.campaignListAsk.sdate = this.rangeDate[0];
      this.campaignListAsk.edate = this.rangeDate[1];

      http
        .request(this.contextPageId, "DTS_AIC_00001", {
          query: this.campaignListAsk,
        })
        .then((response) => {
          const items = [];
          utils.forEach(response.data.list, (obj) => {
            items.push({ text: obj.scheduleName, value: obj.scheduleId });
          });
          this.campaignDropdown = items;
          this.selectedcampaignValue = items;
        });
    },
    onClickSearch(fFirst) {
      // 설정된 시간(5초) 안에 조회가 종료되지 않을 경우, 조회시간 지연 안내 문구 표시
      let timerId = setTimeout(
        () =>
          this.showSnackbar(
            "조회 데이터 양에 따라 지연될 수 있습니다. 잠시만 기다려주세요."
          ),
        5000
      );

      let dataParams = {
        startDate: this.rangeDate[0],
        endDate: this.rangeDate[1],
        campaignIdList: [],
        campaignTypeList: [],
        tellerOption: this.selectedTellerCallType,
        outcallResultData: this.outcallResultData,
        calleeNumber: this.inputcalleenumber,
        outcallResultList: [],
      };
      this.selectedcampaignValue.forEach((obj) => {
        dataParams.campaignIdList.push(obj.value);
      });
      this.selectedScenarioType.forEach((obj) => {
        dataParams.campaignTypeList.push(obj.value);
      });
      this.selectedOutcallResult.forEach((obj) => {
        dataParams.outcallResultList.push(obj.value);
      });

      http
        .request(this.contextPageId, "DTS_AIC_00006", {
          data: dataParams,
        })
        .then((response) => {
          if (response.data.list) {
            this.scenarioProgressMaxSize = 0; // 조회시 초기화
            // 통화결과 flag
            // conversation 데이터
            utils.forEach(response.data.list, (rowobj) => {
              this.scenarioColMax =
                this.scenarioColMax > rowobj.numberOfQuestions
                  ? this.scenarioColMax
                  : rowobj.numberOfQuestions;
              if (!rowobj.calleeNumber) {
                rowobj.calleeNumber = rowobj.calleeNumber1;
              }
              // timezone 보정
              rowobj.startTime =
                aiccUtils.conversationDownload.changeTimeZoneAndFormat(
                  rowobj.startTime
                );
              rowobj.endTime =
                aiccUtils.conversationDownload.changeTimeZoneAndFormat(
                  rowobj.endTime
                );

              // itemStatus, outcallresultcode 확인해서 callresult 값 생성
              //   if (
              //     !rowobj.itemStatus ||
              //     rowobj.itemStatus === "A" ||
              //     (rowobj.itemStatus === "B" && !rowobj.outcallResultCode)
              //   ) {
              //     // 통화 대기
              //     rowobj["callResult"] = "N";
              //   } else {
              //     rowobj["callResult"] = this.getCallResultFlag(
              //       rowobj.outcallResultCode
              //     );
              //   }
              // itemStatus, outcallresultcode 확인해서 callresult 값 생성
              if (!rowobj.itemStatus || rowobj.itemStatus === "A") {
                // 통화 대기
                rowobj["callResult"] = "N";
              } else if (
                rowobj.itemStatus === "B" &&
                !rowobj.outcallResultCode
              ) {
                // 연결중(링잉)
                rowobj["callResult"] = "R";
              } else {
                rowobj["callResult"] = this.getCallResultFlag(
                  rowobj.outcallResultCode
                );
              }
              // 통화대기인 경우 시각정보 표시 않음
              //   rowobj.outcallReqTime =
              //     rowobj.callResult === "N"
              //       ? ""
              //       : aiccUtils.conversationDownload.changeTimeZoneAndFormat(
              //           rowobj.outcallReqTime
              //         );
              // 통화대기, 연결중(링잉)인 경우 시각정보 표시 않음
              rowobj.outcallReqTime =
                rowobj.callResult === "N" || rowobj.callResult === "R"
                  ? ""
                  : aiccUtils.conversationDownload.changeTimeZoneAndFormat(
                      rowobj.outcallReqTime
                    );

              // 시나리오 시작/종료 object 생성
              const scenarioStartEnd = {
                start: rowobj.scenarioStartTime ? "Y" : "N",
                end: rowobj.scenarioEndTime ? "Y" : "N",
              };
              rowobj.retryTimes =
                rowobj.callResult === "N" ? -1 : rowobj.retryTimes + 1;
              rowobj["scenarioStartEnd"] = scenarioStartEnd;
              rowobj["answerSet"] = [];
              utils.forEach(rowobj.answerList, (answerData) => {
                if (answerData.forScenarioProgress) {
                  var data = JSON.parse(answerData.interimData);
                  if (data) {
                    const convdata = {
                      questionTitle: data.questionNumber,
                      questionContents: data.question,
                      answer: data.answer,
                      answerType: data.answerCategory,
                    };
                    rowobj.answerSet.push(convdata);
                  }
                }
              });
              // numberofQuestions 만큼 빈 answerset을 추가해 회색으로 표시한다.
              if (rowobj.answerList.length < rowobj.numberOfQuestions) {
                for (
                  var idx = 0;
                  idx < rowobj.numberOfQuestions - rowobj.answerList.length;
                  idx++
                ) {
                  const convdata = {
                    questionTitle: "",
                    questionContents: "",
                    answer: "",
                    answerType: "",
                  };
                  rowobj.answerSet.push(convdata);
                }
              }

              // 재시도 콜의 item_index를 캠페인 수신리스트 작성시 최초 채번된 item_index로 보정하고, 정해진 수신ID 포맷으로 변환
              rowobj.calleeId = aiccUtils.stringUtil.itemIndexToCalleeId(
                rowobj.itemIndex
              );

              // 시나리오 진행 max size 계산
              this.scenarioProgressMaxSize = Math.max(rowobj.numberOfQuestions, rowobj.answerList.length, this.scenarioProgressMaxSize);
            });

            this.headers[13].width = Math.max((this.scenarioProgressMaxSize * 40), this.scenarioProgressMinSize) + 'px'; // 시나리오 진행 컬럼 width 적용

            console.log(response.data.list);
            // 수행일정 기준으로 내림차순 정렬해 표시
            response.data.list.sort(function (a, b) {
              if (
                a.outcallReqTime.length === 0 &&
                b.outcallReqTime.length === 0
              )
                return 0;
              if (a.outcallReqTime.length === 0) return 1;
              if (b.outcallReqTime.length === 0) return -1;
              return a.outcallReqTime > b.outcallReqTime
                ? -1
                : a.outcallReqTime < b.outcallReqTime
                ? 1
                : 0;
            });
            this.tableItems.setData(response.data.list);
            if (response.data.list.length === 0) {
              if (fFirst !== "1")
                this.tableOptions.msgEmptyData = this.$i18n.t(
                  "MSG_TXT_NO_FILTERED_DATA"
                );
              else
                this.tableOptions.msgEmptyData =
                  this.$i18n.t("MSG_TXT_NO_DATA");
            }
            this.$refs["gridScenario"].initGrid();
            this.$refs["gridScenario"].setScrollTop(0);
          }

          // 설정된 시간 안에 조회 종료시 조회시간 지연 안내 문구 생략
          clearTimeout(timerId);
        })
        .catch((error) => {
          console.warn(error);
        });
    },
    getCallResult(flag) {
      // code map에서 값 조회해 리턴
      return this.callResultTextMap[flag];
    },
    getCallResultFlag(code) {
      // code map에서 값 조회해 리턴
      if (!this.callResultFlagMap[code]) return "G";
      return this.callResultFlagMap[code];
    },
    makeHistoryAskData() {
      let historyDate = "date:" + this.rangeDate[0] + "-" + this.rangeDate[1];
      let scheduleIdList = [];
      let outcallResult = [];
      let scenarioType = [];
      // select box 선택한 값이 있으면 Ask 데이터에 넣는다.
      if (this.selectedcampaignValue.length > 0) {
        for (let schedule of this.selectedcampaignValue) {
          scheduleIdList.push(schedule.value);
        }
      }
      if (this.selectedcampaignValue.length === this.campaignItems.length) {
        scheduleIdList = [];
        scheduleIdList.push("전체");
      }
      if (this.selectedOutcallResult.length > 0) {
        for (let outcall of this.selectedOutcallResult) {
          outcallResult.push(outcall.value);
        }
      }
      if (
        this.selectedOutcallResult.length === this.outcallResultItems.length
      ) {
        outcallResult = [];
        outcallResult.push("전체");
      }
      if (this.selectedScenarioType.length > 0) {
        for (let scenario of this.selectedScenarioType) {
          scenarioType.push(scenario.value);
        }
      }
      if (this.selectedScenarioType.length === this.scenarioTypeItems.length) {
        scenarioType = [];
        scenarioType.push("전체");
      }
      let selectedcampaign = "campaign:" + scheduleIdList.toString();
      let teller = "teller:" + this.selectedTellerCallType;
      let callstatus = "call:" + outcallResult.toString();
      let scenariostatus = "scenario:" + scenarioType.toString();
      let outcallResultData = "outcallResultData:" + this.outcallResultData;
      let callnum = "calleenumber:" + this.inputcalleenumber;

      return (
        historyDate +
        "/" +
        selectedcampaign +
        "/" +
        outcallResultData +
        "/" +
        callstatus +
        "/" +
        scenariostatus +
        "/" +
        callnum
      );
    },
    onClickCommDownload() {
      const sToday = utils.now("YYYYMMDDHHmmss");
      const sCsvName = `conv_history_${sToday}.csv`;

      let historyDataAsk = {
        pageId: this.contextPageId,
        fileName: sCsvName,
        fileDetail: this.makeHistoryAskData(),
      };
      // 다운로드 이력 남기기
      http
        .request(this.contextPageId, "DTS_AIZ_00001", {
          data: historyDataAsk,
        })
        .then((res) => {
          if (res.status === 200) {
            aiccUtils.conversationDownload.getAndMakeConversationFile(
              this.contextPageId,
              sCsvName,
              this.$refs.gridScenario.getViewData()
            );
          } else {
            utils.aiccMessageBox(
              "알림",
              "잠시 후 다시 시도해주세요.",
              "확인",
              null
            );
          }
        });
    },
    getColumnItem(row, data) {
      var item = row[data];
      switch (data) {
        case "callResult":
          item = this.getCallResult(item);
          break;
        case "scenarioStartEnd":
          item =
            (row.scenarioStartTime ? "Y" : "-") +
            " " +
            (row.scenarioEndTime ? "Y" : "-");
          break;
        case "retryTimes":
          if (row.retryTimes === -1) item = "-";
          else item = row.retryTimes.toString() + "회";
          break;
        case "callTxMark":
          item = item === "Y" ? "Y" : "-";
          break;
        case "insertReason":
          item = item === "B" ? "Y" : "-";
          break;
        case "outcallReqTime":
          item = utils.toStringByFormat(item, "YYYY-MM-DD HH:mm");
          break;
        case "startTime":
        case "endTime":
          item = utils.toStringByFormat(item, "HH:mm:ss");
          break;
        case "outcallResultData":
          item = item || "-";
          break;
        case "answerSet":
          item = this.getAnswerSet(item);
          break;
        case "lastQuestionTitle":
          item = this.getLastQuestionTitle(row);
          break;
        default:
          item = item || "";
      }
      return item;
    },
    getAnswerSet(answerArr) {
      // 시나리오 진행 데이터를 문자열로 표현
      let scenarioProgress = "";
      utils.forEach(answerArr, (answer) => {
        if (answer.questionTitle != null && answer.questionTitle !== "") {
          scenarioProgress +=
            answer.questionTitle +
            " " +
            this.getQuestionResult(answer.answerType) +
            ", ";
        }
      });
      scenarioProgress = scenarioProgress.replace(/,\s$/, ""); // 문자열이 ', '로 끝나면 ', ' 삭제
      return scenarioProgress;
    },
    getQuestionResult(answerType) {
      // 질문 결과 데이터를 문자로 표현
      switch (answerType) {
        case "A":
          return "O"; // 질문의도 충족
        case "B":
          return "X"; // 질문의도 미충족
        case "C":
          return "◎"; // 반복 후 의도충족
        case "E":
          return "-"; // 미응답
        default:
          return "";
      }
    },
    getLastQuestionTitle(row) {
      // 마지막 대화ID 가져오기
      let lastQuestionTitle = "";
      var answerArr = row["answerSet"];
      if (answerArr != null && answerArr.length > 0) {
        var lastAnswer = answerArr[answerArr.length - 1];
        lastQuestionTitle = lastAnswer.questionTitle;
      }
      return lastQuestionTitle;
    },
    onClickCsvDownload() {
      const sToday = utils.now("YYYYMMDDHHmmss");
      const sCsvName = `exec_history_${sToday}.csv`;

      let historyData = {
        pageId: this.contextPageId,
        fileName: sCsvName,
        fileDetail: this.makeHistoryAskData(),
      };
      // 다운로드 이력 남기기
      http
        .request(this.contextPageId, "DTS_AIZ_00001", {
          data: historyData,
        })
        .then((res) => {
          if (res.status === 200) {
            this.onDownloadTableToCsv(this.headers, sCsvName);
          } else {
            utils.aiccMessageBox(
              "알림",
              "잠시 후 다시 시도해주세요.",
              "확인",
              null
            );
          }
        });
    },
    onDownloadTableToCsv(headerObj, csvFileNm) {
      var blob, csvUrl, a;
      var csvArray = [];
      // 1. set header
      csvArray.push(headerObj.map((f) => f.text));
      csvArray[0].splice(12, 1); // 대화이력 컬럼만 삭제
      csvArray[0].unshift("세션ID");
      csvArray[0].splice(12, 0, "고객ID");
      csvArray[0].push("마지막 대화ID"); // 시나리오 진행 컬럼 뒤에 추가
      var colValue = headerObj.map((f) => f.value);
      colValue.splice(12, 2);
      colValue.unshift("sessionId");
      colValue.splice(12, 0, "customerId");
      colValue.push("answerSet"); // 시나리오 진행
      colValue.push("lastQuestionTitle"); // 마지막 대화ID
      // 2. set Data
      var gridData = this.$refs.gridScenario.getViewData();
      csvArray = csvArray.concat(
        gridData.map((row) => {
          var rowItem = [];
          colValue.forEach((data) => {
            rowItem.push(this.getColumnItem(row, data));
          });
          return rowItem;
        })
      );
      csvArray = aiccUtils.stringUtil.enclose2DArrayInDoubleQuotes(csvArray);
      const BOM = "\uFEFF";
      var csvString = BOM + csvArray.map((r) => r.join(",")).join("\r\n");
      blob = new Blob([csvString], { type: "text/csv;charset=utf8" });
      csvUrl = URL.createObjectURL(blob);
      a = document.createElement("a");
      a.setAttribute("style", "display:none");
      a.setAttribute("href", csvUrl);
      a.setAttribute("download", csvFileNm);
      document.body.appendChild(a);
      a.click();
      a.remove();
    },

    // 스낵바
    showSnackbar(message) {
      this.$nextTick(() => {
        this.$refs.snackbar.show({ text: message });
      });
    },
  },
};
</script>

<style scoped>
.Rectangle-11216 {
  width: 1px;
  height: 9px;
  margin: 6px 8px 5px;
  border: solid 1px #a5a5a5;
}
.yoo_wordbreak {
  word-break: keep-all;
}
.yoo_minwidth {
  text-overflow: unset;
}
.more_info_yoo {
  position: absolute;
  bottom: 40px;
  display: flex;
  align-items: baseline;
  height: 20px;
  padding-left: 40px;
  font-size: 14px;
  font-family: NotoSansCJKkr;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #959595;
}
::v-deep
  .ur-data-grid__header__cell.yoo_wordbreak
  > .ur-data-grid__header__cell__title
  > .ur-data-grid__header__cell__title__text {
  word-break: keep-all;
  text-overflow: initial;
  white-space: pre-line;
}
::v-deep
  .ur-data-grid__header__cell.yoo_minwidth
  > .ur-data-grid__header__cell__title
  > .ur-data-grid__header__cell__title__text {
  text-overflow: unset;
}
</style>
